import n from "./td-longtail-vue-components203.js";
/* empty css                              */
import o from "./td-longtail-vue-components98.js";
var i = function() {
  var e = this, t = e._self._c, f = e._self._setupProxy;
  return e.offers && e.offers.length > 0 ? t("div", { staticClass: "offer-tiles", class: { "offer-tiles--spaces": e.spaces } }, [e._t("beforeOfferTiles"), e._t("offerTileContainer", function() {
    return [e._l(f.entriesWithProduct, function(r, s) {
      return [e._t("default", null, { offer: r, entry: r, index: s })];
    })];
  }), e._t("afterOfferTiles")], 2) : e._e();
}, _ = [], l = /* @__PURE__ */ o(
  n,
  i,
  _,
  !1,
  null,
  "03661c8e"
);
const m = l.exports;
export {
  m as default
};
